<template>
  <div class="product_centers">
    <nav-header :navs="4" :navsitems="a" />
    <div class="product_type_centers">
      <div class="in-banner">
        <div class="swiper-centers">
          <swiper class="swiper-container" :options="swiperOption">
            <swiper-slide v-for="(item, index) in slideList" :key="index">
              <img :src="item.image" alt="" width="100%" height="auto" />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>

      <div class="product_tit">
          产品中心
        </div>

      <div class="product_type_list">
        <div class="list-item" @click="goPages('a1')">
          <div
            style="
              width: 208px;
              height: 208px;
              margin: 0px auto;
              text-align: center;
            "
          >
            <img src="../../public/imgs/D9.jpg" width="80%" height="auto" />
          </div>
          <div><b>智能仪表</b></div>
        </div>
        <div class="list-item" @click="goPages('a2')">
          <div
            style="
              width: 208px;
              height: 208px;
              margin: 0px auto;
              text-align: center;
            "
          >
            <img src="../../public/imgs/F1.jpg" width="80%" height="auto" />
          </div>
          <div><b>智能集成电力电容补偿装置</b></div>
        </div>
        <div class="list-item" @click="goPages('a3')">
          <div
            style="
              width: 208px;
              height: 208px;
              margin: 0px auto;
              text-align: center;
            "
          >
            <img src="../../public/imgs/A.jpg" width="80%" height="auto" />
          </div>
          <div><b>智能抑谐式集成电力电容补偿装置</b></div>
        </div>
        <div class="list-item" @click="goPages('a4')">
          <div
            style="
              width: 208px;
              height: 208px;
              margin: 0px auto;
              text-align: center;
            "
          >
            <img src="../../public/imgs/C1.jpg" width="80%" height="auto" />
          </div>
          <div><b>电能质量治理装置</b></div>
        </div>
        <div class="list-item" @click="goPages('a5')">
          <div
            style="
              width: 208px;
              height: 208px;
              margin: 0px auto;
              text-align: center;
            "
          >
            <img src="../../public/imgs/C2.jpg" width="80%" height="auto" />
          </div>
          <div><b>综合测控装置</b></div>
        </div>
        <div class="list-item" @click="goPages('a6')">
          <div
            style="
              width: 208px;
              height: 208px;
              margin: 0px auto;
              text-align: center;
            "
          >
            <img src="../../public/imgs/J1.jpg" width="80%" height="auto" />
          </div>
          <div><b>传统式无功补偿器件</b></div>
        </div>
        <div class="list-item" @click="goPages('a7')">
          <div
            style="
              width: 208px;
              height: 208px;
              margin: 0px auto;
              text-align: center;
            "
          >
            <img src="../../public/imgs/Z1.jpg" width="80%" height="auto" />
          </div>
          <div><b>物联终端</b></div>
        </div>
      </div>
    </div>

    <nav-footer />
  </div>
</template>
  <script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import NavHeader from "@/components/NavHeaders.vue";
import NavFooter from "@/components/NavFooter.vue";
export default {
  name: "product",
  components: {
    NavHeader,
    NavFooter,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      a: "",
      product: {}, //商品信息
      swiperOption: {
        autoplay: true,
        loop: true,
        speed: 4000,
        cubeEffect: {
          shadowOffset: 100,
          shadowScale: 0.6,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      slideList: [
        {
          id: "43",
          image: "http://www.jiukaist.com/images/banner/2.png",
        },
        {
          id: "43",
          image: "http://www.jiukaist.com/images/banner/1.png",
        },
      ],
    };
  },

  mounted() {
    //this.getProductInfo();
  },
  methods: {
    goPages(val) {
      let self = this;
      self.$router.push("/product_type_list/" + val);
    },
    // 获取商品信息
    getProductInfo() {
      let id = this.$route.params.id;
      this.$api.mall.getProductInfo(id).then((res) => {
        this.product = res;
      });
    },
  },
};
</script>
  <style lang="scss">
.product_centers {
  width: 100%;
  overflow: hidden;
  background: #f5f5f5;
  .swiper-button-next:after,
  .swiper-container-rtl .swiper-button-prev:after {
    content: "" !important;
  }
  .swiper-button-prev:after,
  .swiper-container-rtl .swiper-button-next:after {
    content: "" !important;
  }
  .swiper-button-next {
    background: url(../../public/imgs/right-c.png) no-repeat center;
    opacity: 0.6;
    width: 42px;
    height: 42px;
    background-size: 42px;
  }
  .swiper-button-prev {
    background: url(../../public/imgs/left-c.png) no-repeat center;
    width: 42px;
    opacity: 0.6;
    height: 42px;
    background-size: 42px;
  }
  .product_tit{
    width: 100%;
    font-weight: 500;
    font-size: 20px;
    overflow: hidden;
    line-height: 1.8;
    text-align: center;
    margin: 18px auto;
  }
  .in-banner {
    width: 100%;
    overflow: hidden;
    margin: 75px auto auto auto;
  }
  .product_type_list {
    width: 1200px;
    padding: 0px;
    box-sizing: border-box;
    overflow: hidden;
    margin: 0px auto;
    padding: 0.82rem 0 2rem;
    .list-item {
      cursor: pointer;
      width: 280px;
      margin-left: 18px;
      margin-top: 18px;
      line-height: 1.5;
      font-size: 16px;
      float: left;
      padding: 10px;
      background: #fff;
      box-sizing: border-box;
      text-align: center;
      img {
        margin: 0px auto;
      }
    }
  }
  .product_type_centers {
    width: 100%;
    padding: 0px;
    box-sizing: border-box;
    overflow: hidden;
    margin: 0px auto;
  }
}
</style>